var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"d":"M32 60.5V4","key":0}),React.createElement("path",{"strokeLinecap":"square","d":"M55 38L32 61 9 38","key":1})]));
}

ArrowDownInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
